module.exports = __webpack_public_path__ + "public/img/Komunikasi Publik Untuk Customer Service.9a49dcbf.png";